import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { render } from "preact";
import Router, { Route } from "preact-router";
import App from "./App";
import BookConsultation from "./booking/BookConsultation";
import "./global.css";

const queryClient = new QueryClient();

render(
	<QueryClientProvider client={queryClient}>
		<Router>
			<Route path="/" component={App} />
			<Route path="/calendar" component={BookConsultation} />
		</Router>
	</QueryClientProvider>,
	document.getElementById("app")!,
);
